import { render, staticRenderFns } from "./SolicitudesDinero.vue?vue&type=template&id=6a405a3b&"
import script from "./SolicitudesDinero.vue?vue&type=script&lang=js&"
export * from "./SolicitudesDinero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports